const pages = [
    {
        path: '/pay-list',
        name: '支付信息',
        type: 0,
        component: () => import('@/views/pay/list')
    },
    {
        path: '/create-order',
        name: '创建订单',
        type: 0,
        component: () => import('@/views/createOrder/list')
    },
    {
        path: '/3d-share',
        name: '分享',
        type: 0,
        component: () => import('@/views/shareMain/list')
    },
    {
        path: '/user-infor',
        name: '个人资料',
        type: 1,
        component: () => import('@/views/userInfor/list')
    },
    {
        path: '/avatar-demo',
        name: '用户头像',
        type: 0,
        component: () => import('@/components/business/avatar-demo.vue')
    },
    {
        path: '/designer',
        name: '设计师主页',
        type: 1,
        component: () => import('@/views/designer/index')
    },
    {
        path: '/auth',
        name: '认证升级',
        type: 1,
        component: () => import('@/views/designer/auth')
    },
    {
        path: '/account',
        name: '账号安全',
        type: 1,
        component: () => import('@/views/account/list')
    },
    {
        path: '/order',
        name: '订单中心',
        type: 0,
        icon: 'el-icon-sell',
        component: () => import('@/views/order/list')
    },
    {
        path: '/',
        redirect: '/user-infor'
    }
]
export default pages



// WEBPACK FOOTER //
// ./src/router/pages.js